import { Column, Row } from '@tanstack/react-table';
import { memo } from 'react';

import { logger } from '@/services/logger';

import { AttributeGridCell } from '../AttributeGridCell';

interface CellProps<TData> {
    row: Row<TData>;
    column: Column<TData>;
}

const CoreCell = <TData,>({ row, column }: CellProps<TData>) => {
    if (
        !column.columnDef.meta?.attribute ||
        !column.columnDef.meta?.collectionAttributeFieldPath ||
        !column.columnDef.meta?.fields
    ) {
        logger.error('Cell: Column meta attributes are missing');
        return null;
    }

    const { attribute, collectionAttributeFieldPath, getValues } = column.columnDef.meta;
    const isReadonly = column.columnDef.meta.readonly;

    const fieldPath = `${collectionAttributeFieldPath}.${row.index}.${attribute.name}`;
    const rowPath = `${collectionAttributeFieldPath}.${row.index}`;

    const currentRowData = getValues ? getValues(rowPath) : row.original;

    return (
        <AttributeGridCell
            attribute={attribute}
            fieldPath={fieldPath}
            rowData={currentRowData}
            rowPath={rowPath}
            rowIndex={row.index}
            readonly={isReadonly}
        />
    );
};

const Cell = memo(CoreCell);

export { Cell };
